// import {
//     VxeInput,
//     VxeNumberInput,
//     VxeUI,
//     VxeTextarea,
//     VxeSelect,
//     VxeCheckbox,
//     VxeRadio,
//     VxeRadioGroup,
//     VxeRadioButton,
//     VxeSwitch,
//     VxeDatePicker,
//     VxeColorPicker,
//     VxeTree,
//     VxeButton,
//     VxeButtonGroup,
//     VxeDrawer,
//     VxeForm,
//     VxeFormGroup,
//     VxeFormItem,
//     VxeIcon,
//     VxeLoading,
//     VxeModal,
//     VxePager,
//     VxePrint,
//     VxeTooltip,
//     VxeUpload,
// } from 'vxe-pc-ui';
import VxeUIAll from 'vxe-pc-ui';
import 'vxe-pc-ui/es/style.css';
import VxeUITable from 'vxe-table';
import 'vxe-table/es/style.css';

import { XQueryLayout } from '@xui/layout';

// 导入主题变量，也可以重写主题变量
import 'vxe-table/lib/style.min.css';
import 'vxe-pc-ui/lib/style.min.css';
import './styles/style.scss';

// 导入默认的语言
// import zhCN from 'vxe-table/lib/locale/lang/zh-CN'; // 中文(简体)

import * as xui from '@xui/components';

// import VxeUIDesign from 'vxe-design';

import './renderer'; // 导入配置表单及表单设计器的组件渲染器

// VxeUI.setTheme('light');
// VxeUI.setI18n('zh-CN', zhCN);
// VxeUI.setLanguage('zh-CN');

// import 'vxe-design/lib/style.css';

export const lazyVxeUI = (app) => {
    app.use(VxeUIAll);
    // app.use(VxeInput);
    // app.use(VxeNumberInput);
    // app.use(VxeTextarea);
    // app.use(VxeSelect);
    // app.use(VxeCheckbox);
    // app.use(VxeRadio);
    // app.use(VxeRadioGroup);
    // app.use(VxeRadioButton);
    // app.use(VxeSwitch);
    // app.use(VxeDatePicker);
    // app.use(VxeColorPicker);
    // app.use(VxeTree);
    // app.use(VxeButton);
    // app.use(VxeButtonGroup);
    // app.use(VxeDrawer);
    // app.use(VxeForm);
    // app.use(VxeFormGroup);
    // app.use(VxeFormItem);
    // app.use(VxeIcon);
    // app.use(VxeLoading);
    // app.use(VxeModal);
    // app.use(VxePager);
    // app.use(VxePrint);
    // app.use(VxeTooltip);
    // app.use(VxeUpload);
    app.component('x-query-layout', XQueryLayout);
};

export const lazyVxeTable = (app) => {
    app.use(VxeUITable);
    // app.use(VxeTable);
    // app.use(VxeColumn);
    // app.use(VxeColgroup);
    // app.use(VxeGrid);
    // app.use(VxeToolbar);
};

export const install = (app) => {
    lazyVxeUI(app);
    lazyVxeTable(app);
    app.use(xui);
    // app.use(VxeUIDesign);
};

export default install;
